var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M7.073 11.858a.47.47 0 0 1-.141-.353c0-.283.22-.502.502-.502l8.135.007c.283 0 .502.219.502.502s-.219.502-.502.502l-8.135-.007a.5.5 0 0 1-.354-.142z"
})));
export { SvgMinus as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDBjNjFiMTdjY2RmODg1NGNlMGY2ZjEzMTViNTIzNDcuc3ZnIjs=";